"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createEmbeddedWorkflow = exports.fetchImportDetails = exports.startEcommImportEpic = exports.fetchEcommStoreDetails = exports.fetchEcommStats = exports.fetchEcommStores = void 0;

var _API = _interopRequireDefault(require("./API"));

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("settings-ui-sdk/EcommerceV2/actions");

var _selectors = require("settings-ui-sdk/EcommerceV2/selectors");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _reduxObservable = require("redux-observable");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _importPollingEpic = require("./importPollingEpic");

var _statsPollingEpic = require("./statsPollingEpic");

var fetchEcommStores = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getStores,
  initiatingActionType: _actions.EcommerceV2ActionTypes.FETCH_STORES,
  requestStatusSelector: _selectors.getFetchStoresRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchStoresActions
}));
exports.fetchEcommStores = fetchEcommStores;
var fetchEcommStats = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchStats,
  initiatingActionType: _actions.EcommerceV2ActionTypes.FETCH_STATS,
  requestStatusSelector: _selectors.getFetchStatsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchStatsActions
}));
exports.fetchEcommStats = fetchEcommStats;
var fetchEcommStoreDetails = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getStoreDetails,
  initiatingActionType: _actions.EcommerceV2ActionTypes.FETCH_STORE_DETAILS,
  requestStatusSelector: _selectors.getFetchStoreDetailsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchStoreDetailsActions
}));
exports.fetchEcommStoreDetails = fetchEcommStoreDetails;
var startEcommImportEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.startImport,
  initiatingActionType: _actions.EcommerceV2ActionTypes.START_IMPORT,
  requestStatusSelector: _selectors.getStartImportRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.StartImportActions
}));
exports.startEcommImportEpic = startEcommImportEpic;
var fetchImportDetails = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchImportDetails,
  initiatingActionType: _actions.EcommerceV2ActionTypes.FETCH_IMPORT_DETAILS,
  requestStatusSelector: _selectors.getFetchImportDetailsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchImportDetailsActions
}));
exports.fetchImportDetails = fetchImportDetails;

var createEmbeddedWorkflow = function createEmbeddedWorkflow($action) {
  return $action.ofType(_actions.EcommerceV2ActionTypes.CREATE_EMBEDDED_WORKFLOW).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload$data = action.payload.data,
        emailType = _action$payload$data.emailType,
        refreshFlowCallback = _action$payload$data.refreshFlowCallback,
        storeToken = _action$payload$data.storeToken;
    return (0, _fromPromise.fromPromise)(_API.default.createEmbeddedWorkflow({
      emailType: emailType,
      storeToken: storeToken
    })).pipe((0, _map.map)(function (response) {
      refreshFlowCallback();
      return _actions.CreateEmbeddedWorkflow.success(response);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.CreateEmbeddedWorkflow.failure(error));
    }), (0, _startWith.startWith)(_actions.CreateEmbeddedWorkflow.request()));
  }));
};

exports.createEmbeddedWorkflow = createEmbeddedWorkflow;

var _default = (0, _reduxObservable.combineEpics)(fetchEcommStores, fetchEcommStoreDetails, startEcommImportEpic, fetchImportDetails, createEmbeddedWorkflow, _importPollingEpic.pollImportEpic, _statsPollingEpic.pollStatsEpic, fetchEcommStats);

exports.default = _default;